// extracted by mini-css-extract-plugin
export var bio = "bio-module--bio--1HYwN";
export var icon = "bio-module--icon--LITtJ";
export var heading = "bio-module--heading--33e98";
export var intro = "bio-module--intro--2OBYI";
export var twitter = "bio-module--twitter---hyh3";
export var linkedin = "bio-module--linkedin--Vqu76";
export var github = "bio-module--github--Dlsv7";
export var codepen = "bio-module--codepen--2Vy3f";